(ns frontend.view.nev.investor.view
  (:require
   [frontend.actions.common :as common-actions]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [potpuri.core :refer [fn->]]
   [common.localization :as loc]
   [common.util :as cu]
   [clojure.string :as string]
   [frontend.logging :as logging]
   [frontend.view.entity-viewers.header :as header]
   [frontend.view.field-templates :as templates]
   [frontend.utils :as fu]
   [frontend.view.nev.events :as events]
   [common.entity :as entity]
   ;;[frontend.view.entity-viewers.entities-editor :as entities-editor]
   [frontend.view.entity-viewers.entity-editor :as entity-editor]
   [frontend.view.not-found :as not-found]
   [frontend.routing :as routing]
   [frontend.view.entity-viewers.event-pane :as event-pane]
   [frontend.view.entity-viewers.modules :as modules]
   [frontend.view.entity-viewers.modules.associated-entities :as associated-entities]
   [frontend.state.current-session :as session]
   [frontend.state.association :as association]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.view.entity-viewers.utils :as entity-utils]
   [frontend.view.syncing-data :as syncing]
   [frontend.db :as app-db]
   [frontend.view.entity-viewers.components :as nev-components]
   [common.schema.field :as field]
   [frontend.state.permissions :as f-permissions]
   [common.schema.registry :as registry]
   ;;[clojure.set :as set]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.view.entity-viewers.modules.risk.view :as risk-module]
   [frontend.view.entity-viewers.modules.risk.event :as risk-event]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn toolbar-buttons
  [{:keys [entity entity-ids]}]
  (let [flagged? (contains? (:account/flagged-entities @session/account)
                            (:db/id entity))]

    (concat
     [(zap-toolbar/dropdown-button
       {:icon      :fa-star
        :on-select (partial common-actions/toggle-flag entity flagged?)
        :ord       1
        :label     (loc/tr (if flagged? :unflag-entity-menu-item :flag-entity-menu-item))})]

     [(when-not (:common/disabled? entity)
        (zap-toolbar/delete-button entity [:investors-grid]))]

     [(nev-components/audit-trail-button {:entity     entity
                                          :entity-ids (vec entity-ids)})])))

(def target-types
  (concat (when-not (session/is-guest?)
            [:entity.type/person
             :entity.type/investor])
          (when (session/portfolio?)
            [:entity.type/holding])))

(defn header-top
  [{:keys [entity read-only?]}]
  [:div
   {:class "flex gap-2"}
   [:span.entity-logo-container.icon-container
    {:style {:padding-left "0"}}
    [:i
     {:class-name (fu/cs :fal (entity/default-icon entity))}]]
   [:div.nev-name-row-container
    [nev-components/name-view
     {:entity     entity
      :read-only? read-only?}]]])

(def default-field-defs
  [{:fields       {0 {:field :investor/description}}
    :field-layout :f-4}])

(defn header-board
  [{:keys [_entity-atom]}]
  (let [header-state (r/atom {:edit-layout? false})
        set-edit-layout! (fn [val] (swap! header-state assoc :edit-layout? val))]
    (fn [{:keys [entity-atom]}]
      (let [edit-layout? (:edit-layout? @header-state)
            entity @entity-atom
            entity-id (:db/id entity)
            field-defs-path [:investor :header :field-defs]
            field-defs-timeout-id :investor-field-defs
            field-defs (or (events/timeout-value field-defs-timeout-id
                                                 @(r/track session/get-view-config field-defs-path))
                           default-field-defs)
            overrides nil
            selected-fields (->> field-defs
                                 (map :fields)
                                 (mapcat vals)
                                 (keep :field))
            remove-fields #{}
            investor-schema (templates/entity-type-template
                             {:entity-type     :entity.type/investor
                              :selected-fields selected-fields
                              :tenant-schema   @session/tenant-schema
                              :account         @session/account
                              :role            @session/role
                              :remove-fields   remove-fields
                              :overrides       overrides})
            asset-system-fields [:company/intelligence-company
                                 :company/fullcontact-company]
            remove-asset-fields asset-system-fields
            legal-entity-schema
            (templates/legal-entity-template
             {:selected-fields (->> selected-fields
                                    (filter vector?)
                                    (filter (fn-> count (= 2)))
                                    (filter (fn-> first (= :investor/legal-entity)))
                                    (map last))
              :remove-fields   remove-asset-fields
              :tenant          @session/tenant
              :tenant-schema   @session/tenant-schema
              :account         @session/account
              :role            @session/role
              :overrides       {:asset/name {:editor/type :editor.type/link
                                             :read-only?  true}}})

            schema (concat investor-schema
                           (->> legal-entity-schema
                                (map (fn [[k fs]]
                                       (let [ref-attribute [:investor/legal-entity k]]
                                         [ref-attribute
                                          (assoc fs :label (templates/legal-entity-label fs))])))))

            ;;test all fields:
            #_#_field-defs
              (->> schema
                   (map first)
                   (partition-all 4 4)
                   (map (fn [fields]
                          (->> fields
                               (map-indexed (fn [i f]
                                              [i {:field f}])))))
                   (map (partial into {}))
                   (map (fn [fields]
                          {:fields       fields
                           :field-layout :f-1-1-1-1}))
                   vec)]
        [:div
         [header/header-board
          {:top              [header-top {:entity entity}]
           :preview-top      [header-top
                              {:entity     entity
                               :read-only? true}]
           :actions          (toolbar-buttons {:entity entity})
           :entity-id        entity-id
           :entity-atom      entity-atom
           :edit-layout?     edit-layout?
           :set-edit-layout! set-edit-layout!
           :field-defs       field-defs
           :schema           schema
           :save-layout!     (fn [new-field-defs]
                               (events/save-field-defs! field-defs-timeout-id
                                                        field-defs-path
                                                        new-field-defs
                                                        (fn [])
                                                        (fn [err]
                                                          (logging/error
                                                           "Failed to save field layout"
                                                           err))))}]]))))

(defn new-header?
  []
  (and (session/has-feature-access? :feature/customizable-nev)
       @session/customizable-nev?))

(defn investor-view
  [{:keys [investor-id] :as _view-args}]
  (let [initialized? (r/atom false)
        state-atom (r/cursor app-db/app-state [:views :nev :investor])
        tenant-schema @session/tenant-schema
        temp-atom (r/cursor state-atom [:temp])
        view-state-atom (r/cursor state-atom [:view-state])
        error-atom (r/cursor state-atom [:error])
        notification-atom (r/cursor state-atom [:notification])
        events-pane-atom (r/cursor state-atom [:events-pane])
        entity-atom (r/cursor session/entities [investor-id])]
    (r/create-class
     {:component-did-update
      (partial entity-utils/component-did-update
               :investor-id
               (partial events/clear-errors! error-atom notification-atom))
      :component-did-mount
      (fn [_]
        (entity-utils/reset-state! state-atom investor-id
                                   {:always-fetch? (session/new-grid-2023?)})
        (reset! initialized? true)
        (when (and (session/risks-access?)
                   (f-permissions/field-read-access? :investor/risk-entities
                                                     :entity.type/investor
                                                     nil))
          (rf/dispatch [::risk-event/load-risks investor-id])))
      :component-will-unmount
      (fn [_]
        (events/clear-errors! error-atom notification-atom)
        (entity-utils/clear-state! state-atom))
      :reagent-render
      (fn [{:keys [investor-id] :as view-args}]
        (let [investor (session/get-entity investor-id)
              legal-entity (session/get-entity (:investor/legal-entity investor))
              tenant-has-funds? (seq @session/all-funds)
              entity-sort (fn [entity]
                            (->> (entity/display-string entity :short @session/entities)
                                 str
                                 string/lower-case))
              investment-vehicles
              (->> (association/resolve-related-entities-by-group investor :entity.type/investor)
                   (mapcat second)
                   (remove :common/disabled?)
                   (keep
                    (fn [a]
                      (let [at (:entity-association/type a)
                            vehicle (case at
                                      :association.type/investment-vehicle
                                      (when (= (:entity-association/source-entity a) investor-id)
                                        (:entity-association/target-entity a))
                                      :association.type/investment-vehicle-of
                                      (when (= (:entity-association/target-entity a) investor-id)
                                        (:entity-association/source-entity a))
                                      nil)]
                        vehicle)))
                   (keep (fn [ivid]
                           (get @session/entities ivid)))
                   (doall))
              investor-ids (set (concat [investor-id]
                                        (->> investment-vehicles
                                             (map :db/id))))]
          (cond
            (not @initialized?)
            [syncing/view]
            (or (:common/disabled? investor)
                (:not-found @state-atom))
            [not-found/not-found-content]
            (:loading @state-atom)
            [syncing/view]
            :else
            (if (or (not investor)
                    (:common/disabled? investor))
              [:div " "]
              (let [investor-commitments (->> @session/fund-commitments
                                              (filter (fn [fc]
                                                        (some #{(:fund-commitment/investor fc)}
                                                              investor-ids)))
                                              (sort-by entity-sort))
                    investor-fundraising-opportunities
                    (->> @session/fundraising-opportunities
                         (filter
                          (fn [fo]
                            (and (some #{(:fundraising-opportunity/investor fo)} investor-ids)
                                 (some #{(:fundraising-opportunity/status fo)}
                                       [:fundraising-opportunity.status/active
                                        :fundraising-opportunity.status/on-hold]))))
                         (sort-by entity-sort))
                    related-sales-opportunities
                    (when (session/sales-pipelines?)
                      (->> @session/sales-opportunities
                           (cu/remove-by :sales-opportunity/status :sales-opportunity.status/lost)
                           (cu/remove-by :sales-opportunity/status :sales-opportunity.status/won)
                           (filter (fn [o]
                                     (some #{(:sales-opportunity/customer o)} investor-ids)))))
                    related-exit-opportunities
                    (when (session/exit-process-management?)
                      (->> @session/exit-opportunities
                           (cu/remove-by :exit-opportunity/status :exit-opportunity.status/lost)
                           (cu/remove-by :exit-opportunity/status :exit-opportunity.status/won)
                           (filter (fn [o]
                                     (some #{(:exit-opportunity/buyer o)} investor-ids)))))

                    related-sale-agreements (when (session/sales-pipelines?)
                                              (->> @session/sale-agreements
                                                   (filter (fn [o]
                                                             (some #{(:sale-agreement/customer o)}
                                                                   investor-ids)))))

                    investor-lost-fundraising-opportunities
                    (->> @session/fundraising-opportunities
                         (filter
                          (fn [fo]
                            (and (some #{(:fundraising-opportunity/investor fo)} investor-ids)
                                 (some #{(:fundraising-opportunity/status fo)}
                                       [:fundraising-opportunity.status/lost]))))
                         (sort-by entity-sort))
                    header-fields [:investor/description]
                    view-id :investor
                    module-collapsed-path (fn [module-id]
                                            [view-id :modules :module-config module-id :collapsed?])
                    selected-commitment-columns (concat (when tenant-has-funds?
                                                          [:fund-commitment/fund
                                                           [:fund-commitment/fund :fund/status]])
                                                        (when (> (count investor-ids) 1)
                                                          [:fund-commitment/investor])
                                                        [:fund-commitment/cur-committed-amount
                                                         :fund-commitment/committed-date
                                                         :fund-commitment/stake]
                                                        (when (tenant-customizations/capman?)
                                                          [:fund-commitment/exit-date]))
                    selected-fundraising-opportunity-columns
                    (concat [:fundraising-opportunity/opportunity-name]
                            (when (> (count investor-ids) 1)
                              [:fundraising-opportunity/investor])
                            [:fundraising-opportunity/pipeline
                             :fundraising-opportunity/probability-category
                             :fundraising-opportunity/datetime-expected-decision
                             :fundraising-opportunity/cur-commitment-amount--sym
                             :fundraising-opportunity/cur-max-commitment-amount
                             :fundraising-opportunity/cur-min-commitment-amount])
                    selected-lost-fundraising-opportunity-columns
                    (concat [:fundraising-opportunity/opportunity-name]
                            (when (> (count investor-ids) 1)
                              [:fundraising-opportunity/investor])
                            [:fundraising-opportunity/pipeline
                             :fundraising-opportunity/lost-reason
                             :fundraising-opportunity/lost-on
                             :fundraising-opportunity/lost-comment])
                    selected-sale-agreement-columns
                    (when (tenant-customizations/capman?)
                      [:sale-agreement/name
                       :sale-agreement/contract-end-date])
                    toolbar-back-to-label (loc/tr :navbar-item/investors-search)
                    show-event-pane? (or (not (session/event-pane-disabled?))
                                         (session/value-creation?))]
                [:<>
                 (when-not (session/is-guest?)
                   [zap-toolbar/nev-toolbar
                    {:state           state-atom
                     :label           (partial zap-toolbar/toolbar-back
                                               [:investors-grid]
                                               toolbar-back-to-label)
                     :actions         (toolbar-buttons (assoc view-args
                                                              :entity
                                                              investor
                                                              :entity-ids
                                                              investor-ids))
                     :dropdown-toggle [:span (loc/tr :actions)
                                       [:i.fas.fa-angle-down.ml-2]]
                     :dropdown-toggle-class-name
                     "zap-button zap-button--primary-btn actions-dropdown"}])
                 [:div.entity__container
                  (when @error-atom
                    [nev-components/error-bar error-atom])
                  (when @notification-atom
                    [nev-components/notification-bar notification-atom])

                  [:div.entity
                   [:div
                    {:class "w-full max-w-[1920px] mx-auto p-4"}
                    (if (new-header?)
                      [header-board {:entity-atom entity-atom}]
                      [nev-components/header-module
                       {:component-state temp-atom
                        :view-state      view-state-atom
                        :related-tags-entity-id (:db/id legal-entity)
                        :entity          investor
                        :selected-fields header-fields}])
                    [:div.md:grid.grid-cols-10.gap-4
                     [:div
                      {:class (if-not show-event-pane?
                                "col-span-10"
                                "col-span-10 lg:col-span-5")}
                      [:div.entity-left
                       [modules/view
                        {:view-id  view-id
                         :ordering (get-in @session/view-config [view-id :modules :ordering])
                         :save-modules-order! (partial events/save-modules-order!
                                                       (:entity/type investor))
                         :modules
                         (concat
                          [;; Note: adding a legal-entity causes entities-editor
                           ;; to remount, which makes error messages disappear. Now
                           ;; that there's one-to-one relationship between investor
                           ;; and its legal-entity, setting a legal-entity to
                           ;; a company/person that is already a legal-entity of
                           ;; another investor fails with an error-message.
                           ;; => for better UX we're using entity-editor for the
                           ;;    investor fields, and a separate entity-relation-module
                           ;;    for the legal-entity fields
                           ;; TODO remove when sure we'll stay with
                           ;;      entity-editor + entity-relation-module approach:
                           #_{:module-id  :investor-info-v3
                              :header     (loc/tr :nev-module/about-this-entity-type
                                                  [(string/lower-case (loc/tr :entity.type/investor))])
                            ;;TODO uncomment when finished:
                              #_:header-tools
                              #_(when (session/is-admin?)
                                  [:span.entity-editor-header-settings
                                   {:on-click (fn [e]
                                              ;;open settings
                                                )}
                                   [:span (loc/tr :entity-editor/settings-label)]
                                   [:i.fal.fa-cog]])
                              :collapsed? (get-in @session/view-config
                                                  (module-collapsed-path :investor-info-v3))
                              :save-module-collapsed! (partial events/save-module-collapsed!
                                                               (:entity/type investor))
                              :content
                              [:div
                               [entities-editor/view
                                {:state-atom       state-atom
                                 :entity-ids       [investor-id (:db/id legal-entity)]
                                 :view-id          view-id
                                 :module-id        :investor-info-v3
                                 :remove-fields
                                 (merge {investor-id (concat [:investor/name :common/network-drive :common/named-network-drives]
                                                             (field/entity-tag-fields tenant-schema
                                                                                      (:entity/type
                                                                                       investor))
                                                             header-fields)}
                                        (when-let [legal-entity-id (:db/id legal-entity)]
                                          (let [legal-entity (get @session/entities legal-entity-id)
                                                entity-fields (->> legal-entity
                                                                   :entity/type
                                                                   (registry/get-schema tenant-schema)
                                                                   (map first)
                                                                   (set))]
                                            (if (= (:entity/type legal-entity) :entity.type/company)
                                              {legal-entity-id (->> (set/difference
                                                                     entity-fields
                                                                     #{:asset/street-address
                                                                       :asset/street-address-2
                                                                       :asset/country
                                                                       :asset/state
                                                                       :asset/city
                                                                       :asset/zip-code
                                                                       :company/website
                                                                       :company/phone})
                                                                    (into []))}
                                              {legal-entity-id (->> (set/difference
                                                                     entity-fields
                                                                     #{:person/universal-email-address
                                                                       :person/last-name
                                                                       :person/first-name
                                                                       :person/universal-phone-number
                                                                       :person/location-address
                                                                       :person/location-city
                                                                       :person/location-state
                                                                       :person/location-country
                                                                       :person/location-zip-code})
                                                                    (into []))}))))
                                 :default-ordering (concat
                                                    (->> [:investor/type :investor/investor-type
                                                          :investor/interest-in-products
                                                          :investor/preferred-currency
                                                          :investor/allocation-split]
                                                         (map (fn [a]
                                                                [investor-id a]))
                                                         (into []))
                                                    (->> [:asset/street-address
                                                          :asset/street-address-2
                                                          :asset/country
                                                          :asset/state
                                                          :asset/city
                                                          :asset/zip-code
                                                          :company/website
                                                          :company/phone]
                                                         (map (fn [a]
                                                                (when legal-entity
                                                                  [(:db/id legal-entity) a])))
                                                         (remove nil?))
                                                    (->> [:person/universal-email-address
                                                          :person/last-name
                                                          :person/first-name
                                                          :person/universal-phone-number
                                                          :person/location-address
                                                          :person/location-city
                                                          :person/location-state
                                                          :person/location-country
                                                          :person/location-zip-code]
                                                         (map (fn [a]
                                                                (when legal-entity
                                                                  [(:db/id legal-entity) a])))
                                                         (remove nil?)))
                                 :ordering         (get-in
                                                    @session/view-config
                                                    [view-id :modules :module-config :investor-info-v3
                                                     :ordering])}]]}
                           (let [module-id :investor-information]
                             {:module-id module-id
                              :state-atom state-atom
                              :entity-id investor-id
                              :view-id view-id
                              :header (loc/tr :nev-module/about-this-entity-type
                                              [(string/lower-case (loc/tr :entity.type/investor))])
                              :collapsed? @(r/track session/get-view-config
                                                    (module-collapsed-path module-id))
                              :save-module-collapsed! (r/partial
                                                       events/save-module-collapsed!
                                                       (:entity/type investor))
                              :content
                              [:div
                               [entity-editor/view
                                {:state-atom state-atom
                                 :entity-id investor-id
                                 :view-id view-id
                                 :module-id module-id
                                 :remove-fields
                                 (concat [:investor/name
                                          :common/network-drive
                                          :common/named-network-drives
                                          :investor/legal-entity]
                                         (field/entity-tag-fields tenant-schema
                                                                  (:entity/type
                                                                   investor))
                                         header-fields)
                                 :ordering @(r/track session/get-view-config
                                                     [view-id :modules
                                                      :module-config
                                                      module-id
                                                      :ordering])}]]})
                           (let [module-id :investor-legal-entity
                                 legal-entity (->> investor
                                                   :investor/legal-entity
                                                   session/get-entity)
                                 legal-entity-type (:entity/type legal-entity)
                                 order-config-path [view-id :modules :module-config module-id
                                                    legal-entity-type :ordering]
                                 collapsed-path (module-collapsed-path module-id)
                                 _collapsed? (get-in @session/view-config collapsed-path)
                                 ;; TODO should we allow this in case fixing
                                 ;;      inconsistent data is needed?:
                                 header-tools nil #_(when (and legal-entity
                                                               false
                                                               (not collapsed?)
                                                               (not (session/is-read-only-user?)))
                                                      [:span.grow.flex.justify-end
                                                       [nev-components/remove-attribute-icon
                                                        {:entity    investor
                                                         :attribute :investor/legal-entity}]])]
                             (nev-components/entity-relation-module
                              {:state-atom        state-atom
                               :module-id         module-id
                               :view-id           view-id
                               :ordering          (get-in
                                                   @session/view-config
                                                   order-config-path)
                               :order-config-path order-config-path
                               :module-label      (loc/tr :nev-module/investor-legal-entity)
                               :entity            investor
                               :header-tools      header-tools
                               :relationship-attribute :investor/legal-entity}))

                           (when (and (session/risks-access?)
                                      (f-permissions/field-read-access? :investor/risk-entities
                                                                        :entity.type/investor
                                                                        nil))
                             (risk-module/risk-module-config
                              {:module-label    (loc/tr :nev-module/investor-risks)
                               :module-id       :holding-risks
                               :view-id         view-id
                               :nev-entity-type :entity.type/investor
                               :save-collapsed-status! (r/partial events/save-module-collapsed!
                                                                  (:entity/type
                                                                   :entity.type/holding))
                               :entity-id       investor-id
                               :add-new-button? false}))

                           (when (and (not (session/is-guest?))
                                      (session/sales-pipelines?)
                                      (seq related-sales-opportunities))
                             (nev-components/association-module-config
                              {:module-label        (loc/tr
                                                     :nev-module/investor-customer-in-sales-oppos)
                               :module-id           :customer-in-sales-oppos
                               :view-id             view-id
                               :nev-entity-type     :entity.type/investor
                               :target-entity-type  :entity.type/sales-opportunity
                               :associated-entities related-sales-opportunities
                               :save-collapsed-status! (partial events/save-module-collapsed!
                                                                (:entity/type investor))
                               :add-new-button?     false}))
                           (when (and (not (session/is-guest?))
                                      (session/sales-pipelines?)
                                      (seq related-sale-agreements))
                             (if (tenant-customizations/capman?)
                               (nev-components/entity-listing-module
                                {:module-id      :customer-in-sale-agreements
                                 :view-id        view-id
                                 :module-title   (loc/tr :nev-module/investor-customer-in-sale-agreements)
                                 :entity         investor
                                 :shown-entities related-sale-agreements
                                 :shown-columns  (->>
                                                  selected-sale-agreement-columns
                                                  (map (fn [k]
                                                         {:key   k
                                                          :label (let [fs (registry/get-field-schema
                                                                           tenant-schema
                                                                           k)]
                                                                   (loc/field-name k fs))})))})
                               (nev-components/association-module-config
                                {:module-label        (loc/tr :nev-module/investor-customer-in-sale-agreements)
                                 :module-id           :customer-in-sale-agreements
                                 :view-id             view-id
                                 :nev-entity-type     :entity.type/investor
                                 :target-entity-type  :entity.type/sale-agreement
                                 :associated-entities related-sale-agreements
                                 :save-collapsed-status! (partial events/save-module-collapsed!
                                                                  (:entity/type investor))
                                 :add-new-button?     false})))
                           (when (and (not (session/is-guest?))
                                      (session/exit-process-management?)
                                      (seq related-exit-opportunities))
                             (nev-components/association-module-config
                              {:module-label        (loc/tr
                                                     :nev-module/investor-buyer-in-exit-oppos)
                               :module-id           :buyer-in-exit-oppos
                               :view-id             view-id
                               :nev-entity-type     :entity.type/investor
                               :target-entity-type  :entity.type/exit-opportunity
                               :associated-entities related-exit-opportunities
                               :save-collapsed-status! (partial events/save-module-collapsed!
                                                                (:entity/type investor))
                               :add-new-button?     false}))

                           (nev-components/entity-listing-module
                            {:module-id      :target-investor-in-commitments
                             :view-id        view-id
                             :module-title   (loc/tr :nev-module/investor-in-commitments)
                             :entity         investor
                             :shown-entities investor-commitments
                             :shown-columns  (->>
                                              selected-commitment-columns
                                              (map (fn [k]
                                                     {:key   k
                                                      :label (let [fs (registry/get-field-schema
                                                                       tenant-schema
                                                                       k)]
                                                               (loc/field-name k fs))})))})
                           (nev-components/entity-listing-module
                            {:module-id      :target-fund-in-fundraising-opportunities
                             :view-id        view-id
                             :module-title   (loc/tr :nev-module/investor-fundraising-opportunities)
                             :entity         investor
                             :shown-entities investor-fundraising-opportunities
                             :shown-columns  (->>
                                              selected-fundraising-opportunity-columns
                                              (map (fn [k]
                                                     {:key   k
                                                      :label (let [fs (registry/get-field-schema
                                                                       tenant-schema
                                                                       k)]
                                                               (loc/field-name k fs))})))})
                           (nev-components/entity-listing-module
                            {:module-id      :target-investor-in-lost-fundraising-opportunities
                             :view-id        view-id
                             :module-title   (loc/tr
                                              :nev-module/investor-in-lost-fundraising-opportunities)
                             :entity         investor
                             :shown-entities investor-lost-fundraising-opportunities
                             :shown-columns  (->> selected-lost-fundraising-opportunity-columns
                                                  (map (fn [k]
                                                         {:key   k
                                                          :label (let [fs (registry/get-field-schema
                                                                           tenant-schema
                                                                           k)]
                                                                   (loc/field-name k fs))})))})]
                          (when-not (session/is-guest?)
                            (associated-entities/modules
                             {:entity-id investor-id
                              :save-module-collapsed! events/save-module-collapsed!
                              :module-collapsed-path module-collapsed-path}))
                          [(when (and (not (session/is-mobile?))
                                      (f-permissions/field-read-access? :common/attachments
                                                                        :entity.type/investor
                                                                        nil))
                             (nev-components/attachments-module view-id
                                                                :investor-attachments
                                                                investor))])}]]]
                     (when show-event-pane?
                       [:div
                        {:class "col-span-10 lg:col-span-5"}
                        [event-pane/view
                         {:state             events-pane-atom
                          :primary-entity-id investor-id
                          :entity-ids        investor-ids
                          :module-args       {:state-atom state-atom
                                              :view-id    view-id}}]])]]]]])))))})))

(defmethod routing/render-view :entity.type/investor
  [{:keys [route-params _view-params]}]
  (let [investor-id (-> route-params
                        :id
                        js/parseInt)]
    [default-page-layout/view
     {:class-name "zap-page investor"}
     ;;the key change forces rerendering of the component (and its child components)
     ^{:key (str "investor-viewer-id-" investor-id)}
     [investor-view {:investor-id investor-id}]]))
